import { supabase } from '../lib/supabase';
export const teamEntityLinkService = {
    // =====================================================
    // WORKSPACE LINKS
    // =====================================================
    async getTeamWorkspaces(teamId) {
        try {
            const { data, error } = await supabase
                .from('team_workspaces')
                .select('workspace_id')
                .eq('team_id', teamId);
            if (error)
                throw error;
            return (data || []).map(d => d.workspace_id);
        }
        catch (error) {
            console.error('Error fetching team workspaces:', error);
            return [];
        }
    },
    async addTeamWorkspace(teamId, workspaceId) {
        try {
            const { error } = await supabase
                .from('team_workspaces')
                .insert({ team_id: teamId, workspace_id: workspaceId });
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error adding team workspace:', error);
            return false;
        }
    },
    async removeTeamWorkspace(teamId, workspaceId) {
        try {
            const { error } = await supabase
                .from('team_workspaces')
                .delete()
                .eq('team_id', teamId)
                .eq('workspace_id', workspaceId);
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error removing team workspace:', error);
            return false;
        }
    },
    // =====================================================
    // GOAL LINKS
    // =====================================================
    async getTeamGoals(teamId) {
        try {
            const { data, error } = await supabase
                .from('team_goals_link')
                .select('goal_id')
                .eq('team_id', teamId);
            if (error)
                throw error;
            return (data || []).map(d => d.goal_id);
        }
        catch (error) {
            console.error('Error fetching team goals:', error);
            return [];
        }
    },
    async addTeamGoal(teamId, goalId) {
        try {
            const { error } = await supabase
                .from('team_goals_link')
                .insert({ team_id: teamId, goal_id: goalId });
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error adding team goal:', error);
            return false;
        }
    },
    async removeTeamGoal(teamId, goalId) {
        try {
            const { error } = await supabase
                .from('team_goals_link')
                .delete()
                .eq('team_id', teamId)
                .eq('goal_id', goalId);
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error removing team goal:', error);
            return false;
        }
    },
    // =====================================================
    // PORTFOLIO LINKS
    // =====================================================
    async getTeamPortfolios(teamId) {
        try {
            const { data, error } = await supabase
                .from('team_portfolios')
                .select('portfolio_id')
                .eq('team_id', teamId);
            if (error)
                throw error;
            return (data || []).map(d => d.portfolio_id);
        }
        catch (error) {
            console.error('Error fetching team portfolios:', error);
            return [];
        }
    },
    async addTeamPortfolio(teamId, portfolioId) {
        try {
            const { error } = await supabase
                .from('team_portfolios')
                .insert({ team_id: teamId, portfolio_id: portfolioId });
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error adding team portfolio:', error);
            return false;
        }
    },
    async removeTeamPortfolio(teamId, portfolioId) {
        try {
            const { error } = await supabase
                .from('team_portfolios')
                .delete()
                .eq('team_id', teamId)
                .eq('portfolio_id', portfolioId);
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error removing team portfolio:', error);
            return false;
        }
    },
    // =====================================================
    // PROJECT LINKS
    // =====================================================
    async getTeamProjects(teamId) {
        try {
            const { data, error } = await supabase
                .from('team_projects')
                .select('project_id')
                .eq('team_id', teamId);
            if (error)
                throw error;
            return (data || []).map(d => d.project_id);
        }
        catch (error) {
            console.error('Error fetching team projects:', error);
            return [];
        }
    },
    async addTeamProject(teamId, projectId) {
        try {
            const { error } = await supabase
                .from('team_projects')
                .insert({ team_id: teamId, project_id: projectId });
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error adding team project:', error);
            return false;
        }
    },
    async removeTeamProject(teamId, projectId) {
        try {
            const { error } = await supabase
                .from('team_projects')
                .delete()
                .eq('team_id', teamId)
                .eq('project_id', projectId);
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error removing team project:', error);
            return false;
        }
    },
    // =====================================================
    // WORKFLOW LINKS
    // =====================================================
    async getTeamWorkflows(teamId) {
        try {
            const { data, error } = await supabase
                .from('team_workflows')
                .select('workflow_id')
                .eq('team_id', teamId);
            if (error)
                throw error;
            return (data || []).map(d => d.workflow_id);
        }
        catch (error) {
            console.error('Error fetching team workflows:', error);
            return [];
        }
    },
    async addTeamWorkflow(teamId, workflowId) {
        try {
            const { error } = await supabase
                .from('team_workflows')
                .insert({ team_id: teamId, workflow_id: workflowId });
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error adding team workflow:', error);
            return false;
        }
    },
    async removeTeamWorkflow(teamId, workflowId) {
        try {
            const { error } = await supabase
                .from('team_workflows')
                .delete()
                .eq('team_id', teamId)
                .eq('workflow_id', workflowId);
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error removing team workflow:', error);
            return false;
        }
    }
};
